module.exports = __webpack_public_path__ + "img/smile.017b92bf.svg";